module.exports = __webpack_public_path__ + "img/Salary.1ea31820.svg";